import PropTypes from 'prop-types';
import React from 'react';

import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { MdDelete, MdEdit } from 'react-icons/md';

import {
  TableActionStyled,
  TableCellHeaderStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
} from './index.style';

export function TableCategories({
  categories,
  editCategoryName,
  openRemovalDialog,
}) {
  return (
    <TableContainerStyled id="categories-table" component={Paper}>
      <Table stickyHeader style={{ height: 500 }}>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellHeaderStyled id="description-column">
              Descrição
            </TableCellHeaderStyled>
            <TableCellHeaderStyled id="edit-column">
              Editar
            </TableCellHeaderStyled>
            <TableCellHeaderStyled id="delete-column">
              Deletar
            </TableCellHeaderStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBody>
          {categories &&
            categories.map((category) => (
              <TableRow
                style={{
                  display: category.name === 'Sem Categoria Definida' && 'none',
                }}
                key={category.id}
              >
                <TableCell>{category.name}</TableCell>
                <TableActionStyled>
                  <IconButton
                    disabled={category.name === 'Sem Categoria Definida'}
                    onClick={() => editCategoryName(category.id)}
                    size="large"
                  >
                    <MdEdit />
                  </IconButton>
                </TableActionStyled>
                <TableActionStyled>
                  <IconButton
                    disabled={category.name === 'Sem Categoria Definida'}
                    onClick={() => openRemovalDialog(category.id)}
                    size="large"
                  >
                    <MdDelete className="delete" />
                  </IconButton>
                </TableActionStyled>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainerStyled>
  );
}

TableCategories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ).isRequired,
  editCategoryName: PropTypes.func.isRequired,
  openRemovalDialog: PropTypes.func.isRequired,
};
